<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">发票信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <div class style="padding-left: 5%;padding-top:26px;">
        <SForm
          ref="firstForm"
          :fields="firstFormfields"
          :data-form="rowdata"
          label-width="100px"
          form-style="width:30%"
          label-position="left"
          :is-show-btn="false"
        />
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">收件人信息</span>
      </div>
      <div class style="padding-left: 5%;padding-top:26px;">
        <SForm
          ref="secondForm"
          :fields="secondFormfields"
          :data-form="rowdata"
          label-width="100px"
          form-style="width:30%"
          label-position="left"
          :is-show-btn="false"
        />
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">票务信息</span>
      </div>
      <div class style="padding-left: 5%;padding-top:26px;">
        <SForm
          ref="lastForm"
          :fields="lastFormfields"
          :data-form="rowdata"
          label-width="100px"
          form-style="width:30%"
          label-position="left"
          :is-show-btn="false"
        />
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">订单信息</span>
      </div>
      <div v-for="(item,index) in orderDetail" :key="index" class style="padding-left: 5%;padding-top:26px;">
        <el-form :inline="true" label-position="left" label-width="80px">
          <el-form-item label="充电单号" style="width: 40%;">
            <div>{{ item.orderNum||'--' }}</div>
          </el-form-item>
          <el-form-item label="实付金额" style="width: 40%;">
            <div>{{ item.totalMoneyRec.toFixed(2) }}</div>
          </el-form-item>
          <el-form-item label="电费" style="width: 40%;">
            <div>{{ item.elecMoneyRec.toFixed(2) }}</div>
          </el-form-item>
          <el-form-item label="服务费" style="width: 40%;">
            <div>{{ item.serviceMoneyRec.toFixed(2) }}</div>
          </el-form-item>
        </el-form>
        <div class="line" />
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Kaipiaoxiangqing',
  components: {},
  data() {
    return {
      rowdata: {},
      firstFormfields: [
        {
          label: '开票状态',
          type: 'div',
          style: 'width:100%',
          prop: 'taxStatus'
        },
        {
          label: '申请用户',
          type: 'div',
          style: 'width:100%',
          prop: 'userName'
        },
        {
          label: '电费',
          type: 'div',
          style: 'width:100%',
          prop: 'elecMoney'
        },
        {
          label: '服务费',
          type: 'div',
          style: 'width:100%',
          prop: 'serviceMoney'
        },
        {
          label: '发票抬头',
          type: 'div',
          style: 'width:100%',
          prop: 'companyName'
        },
        {
          label: '税号',
          type: 'div',
          style: 'width:100%',
          prop: 'taxNo'
        },
        {
          label: '发票形式',
          type: 'div',
          style: 'width:100%',
          prop: 'invoiceForm'
        },
        {
          label: '开户行名称',
          type: 'div',
          style: 'width:100%',
          prop: 'openBankName'
        },
        {
          label: '开户行账号',
          type: 'div',
          style: 'width:100%',
          prop: 'openBankAccountNo'
        },
        {
          label: '注册地址',
          type: 'div',
          style: 'width:100%',
          prop: 'registerAddress'
        },
        {
          label: '电话',
          type: 'div',
          style: 'width:100%',
          prop: 'mobile'
        },
        {
          label: '申请时间',
          type: 'div',
          style: 'width:100%',
          prop: 'applicantTime'
        }
      ],
      secondFormfields: [
        {
          label: '收件人',
          type: 'div',
          style: 'width:100%',
          prop: 'addressee'
        },
        {
          label: '收件地址',
          type: 'div',
          style: 'width:100%',
          prop: 'address'
        },
        {
          label: '收件电话',
          type: 'div',
          style: 'width:100%',
          prop: 'receivePhone'
        },
        {
          label: '收件邮箱',
          type: 'div',
          style: 'width:100%',
          prop: 'receiveMail'
        }
      ],
      lastFormfields: [
        {
          label: '开票结果',
          type: 'div',
          style: 'width:100%',
          prop: 'reason'
        }
      ],
      orderDetail: []

    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    const id = this.$route.query.data
    const data = {
      id: id
    }
    this.$store.dispatch('form/handle', {
      url: '/business/billing/detail',
      data: data,
      method: 'get',
      callback: resp => {
        this.rowdata = resp
        this.rowdata.elecMoney = resp.elecMoney.toFixed(2)
        this.rowdata.serviceMoney = resp.serviceMoney.toFixed(2)
        this.orderDetail = resp.orderDetail
        if (resp.invoiceForm === '0') {
          this.rowdata.invoiceForm = '增值税普通发票'
        } else {
          this.rowdata.invoiceForm = '增值税专用发票'
        }

        if (this.rowdata.taxStatus === 2) {
          this.rowdata.reason = this.rowdata.rejectReason
        } else if (this.rowdata.taxStatus === 3) {
          this.rowdata.reason = this.rowdata.passReason
        } else {
          this.rowdata.reason = '--'
        }

        if (resp.taxStatus === 0) {
          this.rowdata.taxStatus = '可开票'
        } else if (resp.taxStatus === 1) {
          this.rowdata.taxStatus = '待开票'
        } else if (resp.taxStatus === 2) {
          this.rowdata.taxStatus = '已驳回'
        } else {
          this.rowdata.taxStatus = '已开票'
        }
      }
    })
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    cancel() {
      this.$router.go(-1)
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="less" src="" scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.line{
  width: 100%;
  height: 0;
  border-top: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// src/views/ticketManagement/invoiceDetail.vue